type EventNameReset = { ecommerce: null };
type EventName = string | EventNameReset;

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const sendEvent = (
  eventName: EventName,
  props = {},
  callback = () => {},
) => {
  if (typeof eventName === 'undefined' || !eventName) return callback();
  try {
    window.dataLayer = window.dataLayer || [];
    if ((eventName as EventNameReset)?.ecommerce === null) {
      window.dataLayer.push({ ecommerce: null });
    } else {
      window.dataLayer.push({
        event: eventName,
        ...props,
      });
    }
    setTimeout(() => {
      return callback();
    }, 250);
  } catch (err) {
    console.log(err);
  }
};

export const is_gtm_loaded = () => {
  let gtm_started_event = window?.dataLayer?.find(
    element => element['gtm.start'],
  );
  console.log('gtm_started_event: ', gtm_started_event);
  if (!gtm_started_event) {
    return false; // Not even the GTM inline config has executed
  } else if (!gtm_started_event['gtm.uniqueEventId']) {
    return false; // GTM inline config has ran, but main GTM js is not loaded (likely AdBlock, NoScript, URL blocking etc.)
  }
  return true; // GTM is fully loaded and working
};

export function splitCookieForGTM(gaCookie: string | boolean): string {
  if (typeof gaCookie === 'boolean') {
    return '';
  } else {
    let splitCookie = gaCookie.split('.');
    return `${splitCookie[2]}.${splitCookie[3]}`;
  }
}

export function resetSectionActions() {
  window.dataLayer.push({
    'Step Name': null,
    'Step Description': null,
    sectionClicked: null,
  });
}
